export default function createThirdPartyPasswordLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `password:${input.type}` });
    return {
        fillEnabled() {
            return log({
                type: "fill-enabled",
            });
        },
        fillDisabled() {
            return log({
                type: "fill-disabled",
            });
        },
    };
}
